import axios from "axios";
import React, { useState, useEffect, Fragment } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Button } from "react-bootstrap";
import Select from "react-select";
import { Form, Row, Col } from "react-bootstrap";
import { API_URL } from "../../../config";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "../../../store/actions/AuthActions";

const selectStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#cccccc",
    boxShadow: "none",
    "&:focus": { borderColor: "#005dba" },
    "&:hover": { borderColor: "#cccccc" },
    padding: "5px",
    borderRadius: "15px",
  }),
  option: (provided, state) => ({
    ...provided,
    color: "#333",
    padding: 10,
    backgroundColor: state.isFocused ? "#f0f0f0" : "#fff",
    "&:active": { backgroundColor: "#e0e0e0" },
  }),
  placeholder: (provided) => ({ ...provided, color: "#999" }),
  menu: (provided) => ({ ...provided, zIndex: 9999 }),
};

const AddOffer = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const collegeId = useSelector((state) => state.college_id.college_id);

  // Form state
  const [packageValue, setPackageValue] = useState("");
  const [companyId, setCompanyId] = useState(null);
  const [companyName, setCompanyName] = useState("");
  const [companyAddress, setCompanyAddress] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [acceptance, setAcceptance] = useState(1);
  const [jobid, setjobId] = useState(null);
  const [dateOffered, setDateOffered] = useState("");
  const [joiningDate, setJoiningDate] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [companyOptions, setCompanyOptions] = useState([{ value: null, label: "Enter company name" }]);
  const [selectedCompany, setSelectedCompany] = useState(null);

  const [searchJobQuery, setSearchJobQuery] = useState("");
  const [searchStudentQuery, setSearchStudentQuery] = useState("");
  const [jobOptions, setJobOptions] = useState([{ value: null, label: "Add Other Job Role" }]);
  const [studentOptions, setStudentOptions] = useState([{ value: null, label: "Search Student" }]);
  const [selectedJob, setSelectedJob] = useState(null);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [studentId, setStudentId] = useState(null);
  const [educationdetails, setEducationDetails] = useState([]);
  const [isotherJobRole, setisOtherJobRole] = useState(false);
  const [otherJobRole, setOtherJobRole] = useState(null);
  const [position, setPosition] = useState("");
  const [position_id, setPositionId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // Search companies
  useEffect(() => {
    if (searchQuery !== "" && searchQuery.length >= 2) {
      const fetchCompanies = async () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;
        try {
          const response = await axios.get(
            `${API_URL}/api/freshment_portal_apis/GenericAPI/get_company_list`,
            { params: { search: searchQuery }, headers: { Authorization: authToken } }
          );
          const data = response.data.data;
          const options = data.map((company) => ({
            value: company.company_id,
            label: company.company_name,
            company_address: company.company_address,
            company_email: company.company_email,
            company_id: company.company_id,
          }));
          options.unshift({ value: null, label: "Enter company name" });
          setCompanyOptions(options);
        } catch (error) {
          if (error?.response?.status === 401) dispatch(logout());
          console.error("Error fetching companies:", error);
        }
      };
      fetchCompanies();
    } else if (searchQuery === "" || searchQuery == null || searchQuery.length < 2) {
      setCompanyOptions([{ value: null, label: "Enter company name" }]);
    }
  }, [searchQuery]);

  // Search jobs
  useEffect(() => {
    if (searchJobQuery !== "" && searchJobQuery.length >= 2) {
      const fetchJobslistDropdown = async () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;
        try {
          const response = await axios.get(
            `${API_URL}/api/freshment_portal_apis/students/search_job_roles`,
            { params: { search: searchJobQuery, college_id: collegeId }, headers: { Authorization: authToken } }
          );
          const data = response.data.data;
          const optionsjob = data.map((job) => ({
            value: job.id,
            label: job.job_role_name,
          }));
          optionsjob.unshift({ value: null, label: "Add Other Job Role" });
          setJobOptions(optionsjob);
        } catch (error) {
          if (error?.response?.status === 401) dispatch(logout());
          console.error("Error fetching jobs:", error);
        }
      };
      fetchJobslistDropdown();
    } else if (searchJobQuery === "" || searchJobQuery == null || searchJobQuery.length < 2) {
      setJobOptions([{ value: "Add Other Job Role", label: "Add Other Job Role" }]);
    }
  }, [searchJobQuery]);

  // Search students
  useEffect(() => {
    if (searchStudentQuery !== "" && searchStudentQuery.length >= 2) {
      const fetchStudentListDropdown = async () => {
        const userDetails = JSON.parse(localStorage.getItem("userDetails"));
        const authToken = userDetails?.data?.auth_token;
        try {
          const response = await axios.get(
            `${API_URL}/api/freshment_portal_apis/students/search_student_list`,
            { params: { search: searchStudentQuery, college_id: collegeId }, headers: { Authorization: authToken } }
          );
          const data = response.data.data;
          const optionsStudent = data.map((student) => ({
            value: student.email,
            label: student.full_name,
            student_id: student.onboarding_student_id,
            education_details: student.education_details,
          }));
          optionsStudent.unshift({ value: null, label: "Search Student" });
          setStudentOptions(optionsStudent);
        } catch (error) {
          if (error?.response?.status === 401) dispatch(logout());
          console.error("Error fetching students:", error);
        }
      };
      fetchStudentListDropdown();
    } else if (searchStudentQuery === "" || searchStudentQuery == null || searchStudentQuery.length < 2) {
      setStudentOptions([{ value: null, label: "Search Student" }]);
    }
  }, [searchStudentQuery]);

  const handleAddOffer = async () => {
    const offerData = {
      package: packageValue,
      job_id: jobid,
      position_id: position_id,
      other_position: otherJobRole,
      acceptance: acceptance,
      date_offered: dateOffered,
      joining_date: joiningDate,
      student_id: studentId,
      company_id: companyId,
      other_company_name: companyName,
      other_company_email: companyEmail,
      other_company_address: companyAddress,
    };

    if (!offerData.student_id) {
      toast.error("Please select a student.");
      return;
    }
    if (offerData.package == null || offerData.package === "") {
      toast.error("Please enter package.");
      return;
    }
    if (offerData.date_offered == null || offerData.date_offered === "") {
      toast.error("Please enter date offered.");
      return;
    }

    const params = new URLSearchParams();
    params.append("college_id", collegeId);
    params.append("package", offerData.package);
    params.append("job_id", offerData.job_id);
    if (offerData.position_id == null) {
      params.append("other_position", offerData.other_position);
    } else {
      params.append("job_role_id", offerData.position_id);
    }
    params.append("acceptance", offerData.acceptance);
    params.append("date_offered", offerData.date_offered);
    params.append("joining_date", offerData.joining_date);
    params.append("student_id", offerData.student_id);
    if (offerData.company_id == null || offerData.company_id === "") {
      params.append("other_company_name", offerData.other_company_name);
      params.append("other_company_email", offerData.other_company_email);
      params.append("other_company_address", offerData.other_company_address);
    } else {
      params.append("company_id", offerData.company_id);
    }

    const userDetails = JSON.parse(localStorage.getItem("userDetails"));
    const authToken = userDetails?.data?.auth_token;

    setIsSubmitting(true);
    try {
      const response = await axios.post(
        `${API_URL}/api/freshment_portal_apis/PlaceOffer/save_job_placement_offer`,
        params,
        { headers: { Authorization: authToken } }
      );
      if (response.data.success) {
        toast.success("The job placement offer has been added successfully.");
        history.push("/offer-table");
      } else {
        toast.error(response.data.message || "There was an error adding the offer. Please try again.");
      }
    } catch (error) {
      if (error?.response?.status === 401) dispatch(logout());
      toast.error("There was an error adding the offer. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Fragment>
      {/* Page Header */}
      <div className="d-flex align-items-center mb-4">
        <Button
          variant="primary"
          size="sm"
          onClick={() => history.push("/offer-table")}
        >
         <i className="fa fa-arrow-left"></i> Back
        </Button>
        <h4
          className="fs-22 font-w600 mb-0 flex-grow-1 text-center"
        >
          Add Job Offer
        </h4>
        <div style={{ width: "60px" }} />
      </div>

      {/* Form Card */}
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h5 className="card-title mb-0">Offer Information</h5>
          </div>
          <div className="card-body">
            <Form>
              {/* Search Company */}
              <Form.Group controlId="formCompanySearch" className="mb-3">
                <Form.Label>Search Company</Form.Label>
                <Select
                  options={companyOptions}
                  value={selectedCompany}
                  filterOption={() => true}
                  onChange={(option) => {
                    if (!option || option.value === null) {
                      setSelectedCompany(null);
                      setCompanyName("");
                      setCompanyAddress("");
                      setCompanyEmail("");
                      setCompanyId(null);
                    } else {
                      setSelectedCompany(option);
                      setCompanyName(option.label);
                      setCompanyAddress(option.company_address);
                      setCompanyEmail(option.company_email);
                      setCompanyId(option.value);
                    }
                  }}
                  onInputChange={(inputValue) => setSearchQuery(inputValue)}
                  placeholder="Enter company name"
                  styles={selectStyles}
                />
              </Form.Group>

              {/* Company Name */}
              <Form.Group controlId="formCompanyName" className="mb-3">
                <Form.Label>Company Name</Form.Label>
                <Form.Control
                  type="text"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  disabled={selectedCompany != null}
                />
              </Form.Group>

              {/* HR Email */}
              <Form.Group controlId="formCompanyEmail" className="mb-3">
                <Form.Label>HR Email</Form.Label>
                <Form.Control
                  type="text"
                  value={companyEmail}
                  onChange={(e) => setCompanyEmail(e.target.value)}
                  disabled={selectedCompany != null}
                />
              </Form.Group>

              {/* Company Address */}
              <Form.Group controlId="formCompanyAddress" className="mb-3">
                <Form.Label>Company Address</Form.Label>
                <Form.Control
                  type="text"
                  value={companyAddress}
                  onChange={(e) => setCompanyAddress(e.target.value)}
                  disabled={selectedCompany != null}
                />
              </Form.Group>

              <Form.Row>
                {/* Job ID */}
                <Form.Group as={Col} controlId="formjobId" className="mb-3">
                  <Form.Label>Job ID ( optional )</Form.Label>
                  <Form.Control
                    type="number"
                    value={jobid}
                    onChange={(e) => setjobId(e.target.value)}
                    onWheel={(e) => e.target.blur()}
                  />
                </Form.Group>

                {/* Search Student */}
                <Form.Group controlId="formStudentSearch" className="mb-3">
                  <Form.Label>Search Student ( Name / Email )</Form.Label>
                  <Select
                    options={studentOptions}
                    value={selectedStudent}
                    filterOption={() => true}
                    onChange={(option) => {
                      if (!option || option.value === null) {
                        setSelectedStudent(null);
                        setStudentId(null);
                        setEducationDetails("");
                      } else {
                        setSelectedStudent(option);
                        setStudentId(option.student_id);
                        setEducationDetails(option.education_details);
                      }
                    }}
                    onInputChange={(inputValue) => setSearchStudentQuery(inputValue)}
                    placeholder="Search Student"
                    styles={selectStyles}
                  />
                </Form.Group>

                {/* Student detail preview */}
                {selectedStudent && selectedStudent !== null && (
                  <div
                    className="card mb-3"
                    style={{
                      width: "100%",
                      border: "1px solid #ccc",
                      borderRadius: "10px",
                      backgroundColor: "#fff",
                      boxShadow: "none",
                    }}
                  >
                    <div className="card-body" style={{ padding: "20px" }}>
                      <p className="d-flex align-items-center w-100" style={{ gap: 10 }}>
                        <span style={{ fontWeight: "bold", width: "110px" }}>Student Name</span>
                        <span style={{ fontWeight: "bold", width: "10px" }}>:</span>
                        {selectedStudent.label}
                      </p>
                      <p className="d-flex align-items-center w-100" style={{ gap: 10 }}>
                        <span style={{ fontWeight: "bold", width: "110px" }}>Student Email</span>
                        <span style={{ fontWeight: "bold", width: "10px" }}>:</span>
                        {selectedStudent.value}
                      </p>
                      <p className="d-flex mb-0 align-items-center w-100" style={{ gap: 10 }}>
                        <span style={{ fontWeight: "bold", width: "110px" }}>Education</span>
                        <span style={{ fontWeight: "bold", width: "10px" }}>:</span>
                        {selectedStudent.education_details}
                      </p>
                    </div>
                  </div>
                )}

                {/* Select Job Role */}
                <Form.Group controlId="formJobSearch" className="mb-3">
                  <Form.Label>Select Job Role</Form.Label>
                  <Select
                    options={jobOptions}
                    value={selectedJob}
                    filterOption={() => true}
                    onChange={(option) => {
                      if (!option || option.label === "Add Other Job Role" || option.value === null) {
                        setSelectedJob(option);
                        setPosition(null);
                        setPositionId(null);
                        setisOtherJobRole(true);
                      } else if (option.label === "Select Job Role" || option.value === null) {
                        setisOtherJobRole(false);
                        setSelectedJob(null);
                      } else {
                        setisOtherJobRole(false);
                        setSelectedJob(option);
                        setPosition(option.label);
                        setPositionId(option.value);
                      }
                    }}
                    onInputChange={(inputValue) => setSearchJobQuery(inputValue)}
                    placeholder="Select Job Role"
                    styles={selectStyles}
                  />
                </Form.Group>

                {/* Other Job Role */}
                {isotherJobRole && (
                  <Form.Group controlId="formPosition" className="mb-3">
                    <Form.Label>Other Job Role</Form.Label>
                    <Form.Control
                      type="text"
                      value={otherJobRole}
                      onChange={(e) => setOtherJobRole(e.target.value)}
                    />
                  </Form.Group>
                )}

                {/* Package */}
                <Form.Group as={Col} controlId="formPackage" className="mb-3">
                  <Form.Label>Package</Form.Label>
                  <Form.Control
                    type="number"
                    value={packageValue}
                    onWheel={(e) => e.target.blur()}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (!isNaN(value)) setPackageValue(value);
                    }}
                    onKeyDown={(e) => {
                      if (
                        e.key !== "Backspace" &&
                        e.key !== "Tab" &&
                        e.key !== "Delete" &&
                        e.key !== "ArrowLeft" &&
                        e.key !== "ArrowRight" &&
                        e.key !== "ArrowUp" &&
                        e.key !== "ArrowDown" &&
                        e.key !== "Enter" &&
                        e.key !== "Escape" &&
                        (e.key < "0" || e.key > "9")
                      ) {
                        e.preventDefault();
                      }
                    }}
                  />
                </Form.Group>
              </Form.Row>

              {/* Offer Acceptance */}
              <Form.Group controlId="formOfferAcceptance" className="mb-3">
                <Form.Label>Offer Acceptance</Form.Label>
                <div>
                  <Form.Check
                    inline
                    type="radio"
                    label="Accepted"
                    value="1"
                    name="acceptance"
                    onChange={() => setAcceptance(1)}
                    checked={acceptance === 1}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    label="Rejected"
                    value="0"
                    name="acceptance"
                    onChange={() => setAcceptance(0)}
                    checked={acceptance === 0}
                  />
                </div>
              </Form.Group>

              <Form.Row>
                {/* Offer Date */}
                <Form.Group as={Col} controlId="formDateOffered" className="mb-3">
                  <Form.Label>Offer Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={dateOffered}
                    onChange={(e) => setDateOffered(e.target.value)}
                  />
                </Form.Group>

                {/* Joining Date */}
                <Form.Group as={Col} controlId="formJoiningDate" className="mb-3">
                  <Form.Label>Joining Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={joiningDate}
                    onChange={(e) => setJoiningDate(e.target.value)}
                  />
                </Form.Group>
              </Form.Row>

              {/* Action Buttons */}
              <div className="d-flex gap-3 mt-2">
                <Button
                  variant="danger btn-sm"
                  onClick={() => history.push("/offer-table")}
                >
                  Cancel
                </Button>
                <Button
                  variant="primary btn-sm"
                  onClick={handleAddOffer}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                        aria-hidden="true"
                      ></span>
                      Saving...
                    </>
                  ) : (
                    "Save Offer"
                  )}
                </Button>
              </div>
            </Form>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AddOffer;
